import React from 'react';
import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';
import Button from '../components/UI/Button';
import Card from '../components/UI/Card';

const Login: React.FC = () => {
  const auth = useAuth();

  // If already authenticated, redirect to dashboard
  if (auth.isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // Show spinner while loading
  if (auth.isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  const handleLogin = () => {
    auth.signinRedirect();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full">
        <Card>
          <div className="p-8">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold text-gray-900 mb-2">Synapse Admin</h1>
              <p className="text-gray-600">Sign in to access the admin panel</p>
            </div>

            {auth.error && (
              <div className="bg-red-50 text-red-700 p-4 rounded-md mb-6">
                {auth.error.message || 'An error occurred during authentication.'}
              </div>
            )}

            <Button
              onClick={handleLogin}
              variant="primary"
              className="w-full"
            >
              Sign in with SSO
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Login;